import { DefaultLink } from '~/components';

export const ContactLink = ({
  href,
  children,
}: {
  href: string;
  children: React.ReactNode;
}) => (
  <DefaultLink
    className="group flex w-full text-primary-950 sm:justify-between"
    href={href}
    underline={false}
  >
    {children}
  </DefaultLink>
);
